import { render, staticRenderFns } from "./ListAlbumsFeatured.vue?vue&type=template&id=38a92684&scoped=true&"
import script from "./ListAlbumsFeatured.vue?vue&type=script&lang=js&"
export * from "./ListAlbumsFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListAlbumsFeatured.vue?vue&type=style&index=0&id=38a92684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a92684",
  null
  
)

export default component.exports